import { render } from "./ModalBestellung.vue?vue&type=template&id=55d23f39"
import script from "./ModalBestellung.vue?vue&type=script&lang=js"
export * from "./ModalBestellung.vue?vue&type=script&lang=js"

import "./ModalBestellung.vue?vue&type=style&index=0&id=55d23f39&lang=css"

import exportComponent from "C:\\Git-Local\\afm.git\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__